/**
 * @desc 基础数据模块
 */
import { baseAxios, baseAxiosDirect } from '../httpInstance';
import { API_BASE } from '@/shared/config';
// desc 获取车辆所在地省份
export function getPositionProvince(payload) {
    return baseAxios({
        method: 'get',
        url: 'getProvince',
        params: payload,
    });
}
// desc 获取车辆所在地省份对应的地市
export function getPositionCity(payload) {
    return baseAxios({
        method: 'get',
        url: 'getCity',
        params: payload,
    });
}
// desc 基础字典数据
export function getKeyValue(payload) {
    return baseAxios({
        method: 'GET',
        url: 'getKeyValue',
        params: payload,
    });
}
// desc 文件上传
export function uploadImage(payload) {
    return baseAxiosDirect({
        method: 'POST',
        url: 'uploadImage',
        data: payload,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        timeout: 20000,
    });
}
// 导出
export const globalExport = (params) => {
    return baseAxiosDirect({
        url: 'baseExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// 查询key value
export const getKeyValueListByTypeId = (params) => {
    return baseAxios({
        url: 'getKeyValueListByTypeId',
        method: 'get',
        params,
    });
};
// 上传图片url
export const uploadImgUrl = `${API_BASE.baseServiceDirect}/uploadApi/uploadImage.json`;
// 订单上传图片
export const orderUploadImgUrl = `${API_BASE.baseServiceDirect}/uploadApi/uploadPicOss`;
// 查询卖家结算设置
export const getSellerPayConfig = (params) => {
    return baseAxios({
        url: 'getSellerPayConfig',
        method: 'get',
        params,
    });
};
// 修改/创建卖家结算设置 /sellerPayConfigApi/getSellerPayConfig.json
export const createSellerPayConfig = (params) => {
    return baseAxios({
        url: params.isFirstCreate ? 'createSellerPayConfig' : 'modifySellerPayConfig',
        method: 'POST',
        data: params.data,
    });
};
// 租户的过户保证金配置规则相关接口 - 查询租户的过户保证金
export const getTransferFrozenMoney = (params) => {
    return baseAxios({
        url: 'getTransferFrozenMoney',
        method: 'get',
        params,
    });
};
// 租户的过户保证金配置规则相关接口 - 保存租户的过户保证金
export const saveTransferFrozenMoney = (params) => {
    return baseAxios({
        url: 'saveTransferFrozenMoney',
        method: 'POST',
        data: params,
    });
};
// 保存卖家打款配置
export const savePaymentWorkFlowConf = (params) => {
    return baseAxios({
        url: 'savePaymentWorkFlowConf',
        method: 'get',
        params,
    });
};
// 获取卖家打款配置
export const getPaymentWorkFlowConf = (params) => {
    return baseAxios({
        url: 'getPaymentWorkFlowConf',
        method: 'get',
        params,
    });
};
// 获取键值对信息参数列表
export const getKeyValueListByQueries = (data) => {
    return baseAxios({
        url: 'getKeyValueListByQueries',
        method: 'POST',
        data,
    });
};
// (初始设置)设置
export const setKeyValueOperate = (data) => {
    return baseAxios({
        url: 'setKeyValueOperate',
        method: 'POST',
        data,
    });
};
// (更新)修改键值对参数值
export const updateKeyValueOperate = (data) => {
    return baseAxios({
        url: 'updateKeyValueOperate',
        method: 'POST',
        data,
    });
};
